"use client";

import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { cn } from "@/lib/utils";

const TRANSACTIONS = [
  {
    token: "Bitcoin (BTC)",
    type: "claimed",
    amount: {
      value: 2,
      currency: "BTC",
    },
    price: 97000,
    total: 4597.8,
    date: "11 Nov, 2024",
  },
  {
    token: "Solana (SOL)",
    type: "claimed",
    amount: {
      value: 25.5,
      currency: "SOL",
    },
    price: 245,
    total: 624.75,
    date: "02 Oct, 2024",
  },
  {
    token: "Ethereum (ETH)",
    type: "available",
    amount: {
      value: 12.8,
      currency: "ETH",
    },
    price: 3300,
    total: 6124.8,
    date: "---",
  },
  {
    token: "Solana (SOL)",
    type: "claimed",
    amount: {
      value: 10,
      currency: "SOL",
    },
    price: 245,
    total: 2450,
    date: "07 Apr, 2024",
  },
  {
    token: "Bitcoin (BTC)",
    type: "expired",
    amount: {
      value: 0.125,
      currency: "BTC",
    },
    price: 97000,
    total: 12125,
    date: "02 Mar, 2024",
  },
  {
    token: "Ethereum (ETH)",
    type: "expired",
    amount: {
      value: 0.01,
      currency: "ETH",
    },
    price: 3300,
    total: 33,
    date: "10 Jan, 2024",
  },
];

const STATUS_TYPE: Record<string, string> = {
  claimed: "success",
  available: "info",
  expired: "destructive",
};

const FILTERS = ["all", "claimed", "available"];

const formatNumber = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export function RewardsHistoryTable() {
  const [filter, setFilter] = React.useState("all");

  return (
    <Card className="bg-transparent">
      <CardHeader className="flex-row flex-wrap items-center justify-between gap-4 px-6 pt-5 pb-6">
        <CardTitle className="text-lg">Rewards History</CardTitle>
        <div className="flex items-center gap-1.5">
          {FILTERS.map((item, key) => (
            <Badge
              key={key}
              onClick={() => setFilter(item)}
              className={cn("cursor-pointer capitalize", {
                "bg-primary text-primary-foreground border-primary":
                  filter === item,
              })}
            >
              {item}
            </Badge>
          ))}
        </div>
      </CardHeader>
      <CardContent className="relative px-6 pt-0 pb-6">
        <div className="relative max-h-72 w-full overflow-auto">
          <Table className="min-w-[640px]">
            <TableHeader>
              <TableRow className="sticky top-0">
                <TableHead className="w-[140px]">Token</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Amount</TableHead>
                <TableHead>Price</TableHead>
                <TableHead>Total</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {TRANSACTIONS.map(
                ({ token, type, amount, price, total, date }, key) => {
                  const tokenName = token.split(" ")[0];
                  const tokenSymbol = token.split(" ")[1];

                  return (
                    <TableRow key={key}>
                      <TableCell>
                        {tokenName}{" "}
                        <span className="text-foreground">{tokenSymbol}</span>
                      </TableCell>
                      <TableCell>
                        <Badge
                          variant={STATUS_TYPE[type] as never}
                          className="px-1.5 py-px text-[10px] capitalize"
                        >
                          {type}
                        </Badge>
                      </TableCell>
                      <TableCell>
                        {new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                        }).format(amount.value)}{" "}
                        <span className="text-foreground">
                          {amount.currency}
                        </span>
                      </TableCell>
                      <TableCell>{formatNumber.format(price)}</TableCell>
                      <TableCell>{formatNumber.format(total)}</TableCell>
                      <TableCell>{date}</TableCell>
                    </TableRow>
                  );
                },
              )}
            </TableBody>
          </Table>
        </div>
        <div className="from-background-dark absolute bottom-[23px] left-0 h-12 w-full bg-linear-to-t to-transparent" />
      </CardContent>
    </Card>
  );
}
